var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskScoring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22.5,
    r: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 18.5C24.2091 18.5 26 20.2909 26 22.5C26 24.7091 24.2091 26.5 22 26.5C19.7909 26.5 18 24.7091 18 22.5C18 20.2909 19.7909 18.5 22 18.5ZM23.3333 22.5C23.3333 21.7636 22.7364 21.1667 22 21.1667C21.2636 21.1667 20.6667 21.7636 20.6667 22.5C20.6667 23.2364 21.2636 23.8333 22 23.8333C22.7364 23.8333 23.3333 23.2364 23.3333 22.5Z",
    fill: "#0B0B17"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 22.5C10 15.8726 15.3726 10.5 22 10.5C28.6274 10.5 34 15.8726 34 22.5C34 29.1274 28.6274 34.5 22 34.5C15.3726 34.5 10 29.1274 10 22.5ZM14.4913 16.9554C16.1914 14.657 18.9217 13.1667 22 13.1667C25.0783 13.1667 27.8086 14.657 29.5087 16.9554C27.654 15.6112 25.161 14.5 22 14.5C18.839 14.5 16.346 15.6112 14.4913 16.9554ZM14.4913 28.0446C16.346 29.3888 18.839 30.5 22 30.5C25.161 30.5 27.654 29.3888 29.5087 28.0446C27.8086 30.343 25.0783 31.8333 22 31.8333C18.9217 31.8333 16.1914 30.343 14.4913 28.0446ZM12.8779 22.5C12.9349 22.4111 12.9988 22.3143 13.0696 22.2106C13.4565 21.6444 14.0434 20.8872 14.8362 20.1322C16.4195 18.6243 18.7735 17.1667 22 17.1667C25.2265 17.1667 27.5805 18.6243 29.1638 20.1322C29.9566 20.8872 30.5435 21.6444 30.9304 22.2106C31.0012 22.3143 31.0651 22.4111 31.1221 22.5C31.0651 22.5889 31.0012 22.6857 30.9304 22.7894C30.5435 23.3556 29.9566 24.1128 29.1638 24.8678C27.5805 26.3757 25.2265 27.8333 22 27.8333C18.7735 27.8333 16.4195 26.3757 14.8362 24.8678C14.0434 24.1128 13.4565 23.3556 13.0696 22.7894C12.9988 22.6857 12.9349 22.5889 12.8779 22.5Z",
    fill: "#0B0B17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskScoring);
export default __webpack_public_path__ + "static/media/risk-scoring.08377289dbe3613a8e3309b8f502e19a.svg";
export { ForwardRef as ReactComponent };